import React, { useState, useEffect } from 'react';

export default function DeleteConfirmModal({ show, onClose, onCancel, onConfirm, itemName, name, title, actionType = "delete", requireTyping = false }) {
    const [typedName, setTypedName] = useState('');
    const handleClose = onClose || onCancel;

    // Reset input when modal opens
    useEffect(() => {
        if (show) {
            setTypedName('');
        }
    }, [show]);

    if (!show) return null;

    const safeItemName = (itemName || name || '').toString();
    const hasItemName = safeItemName.trim() !== '';
    const isMatch = !requireTyping || !hasItemName || (typedName.trim().toLowerCase() === safeItemName.trim().toLowerCase());

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
            <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1055, background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px' }}>
                        <div className="modal-header border-0 pb-0">
                            <h5 className="modal-title fw-bold text-danger">
                                <i className="fa fa-exclamation-triangle me-2"></i>
                                {title || (actionType === "cancel" ? "Confirm Cancellation" : "Confirm Deletion")}
                            </h5>
                            <button type="button" className="btn-close" onClick={handleClose}></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                Are you sure you want to {actionType} {hasItemName ? <strong>{safeItemName}</strong> : 'this item'}?
                            </p>
                            {actionType === "delete" && (
                                <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                                    The item will be moved to the Trash for 15 days before being permanently deleted.
                                </p>
                            )}
                            
                            {requireTyping && hasItemName && (
                                <div className="mt-4 bg-light p-3 rounded border">
                                    <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
                                        Please type <strong>{safeItemName}</strong> to confirm:
                                    </label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={typedName}
                                        onChange={(e) => setTypedName(e.target.value)}
                                        autoFocus
                                        autoComplete="off"
                                    />
                                </div>
                            )}
                        </div>
                        <div className="modal-footer border-0 pt-0">
                            <button type="button" className="btn btn-light" onClick={handleClose}>
                                Cancel
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-danger px-4" 
                                onClick={onConfirm}
                                disabled={!isMatch}
                            >
                                <i className="fa fa-trash me-2"></i> {actionType === "cancel" ? "Cancel Bill" : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

